import React, { useState, useEffect } from 'react';
import './PayrollComponent.css';
import InputOption from '../../../../../../component/Input/InputOption';
import CurrencyInput from '../../../../../../helpers/CurrencyInput';

const PayrollCompnent = ({ show, onClose, apply, options }) => {
    const [payrollComponent, setPayrollComponent] = useState('');
    const [payrollComponentAmount, setPayrollComponentAmount] = useState(0);
    const [textButton, setTextButton] = useState('Simpan');

    const handleOptionChange = (e) => {
        const selectedValue = e.target.value;
        setPayrollComponent(selectedValue);
    };

    const handleSave = () => {
        apply({
            "name" : payrollComponent,
            "amount" : payrollComponentAmount,
        })
        onClose();
    };

    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h4>Nomor Transaksi</h4>
                    <button className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <label htmlFor="payrol-component">Payroll component</label>
                        <select id="payrol-component" value={payrollComponent} onChange={handleOptionChange}>
                            {options.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="amount">Nominal</label>
                        <CurrencyInput/>
                        {/* <input
                            id="amount"
                            type="number"
                            placeholder="1001"
                            value={payrollComponentAmount}
                            onChange={(e) => setPayrollComponentAmount(e.target.value)}
                        /> */}
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="save-button" onClick={handleSave}>
                        {textButton}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PayrollCompnent;
